import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Layout } from '../components/Layout';
import { VideoUpload } from '../components/VideoUpload';
import { VideoLibrary } from '../components/VideoLibrary';

export function Videos() {
  const [showUpload, setShowUpload] = useState(false);

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Video Library</h1>
            <p className="mt-2 text-gray-600">
              Upload and manage your exercise videos
            </p>
          </div>
          <button
            onClick={() => setShowUpload(!showUpload)}
            className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
          >
            <Plus className="w-5 h-5" />
            {showUpload ? 'Hide Upload' : 'Upload Video'}
          </button>
        </div>

        {showUpload && (
          <div className="mb-6">
            <VideoUpload
              onUploadComplete={() => setShowUpload(false)}
              onCancel={() => setShowUpload(false)}
            />
          </div>
        )}

        <VideoLibrary />
      </div>
    </Layout>
  );
}
